function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import ParagraphComponent from "/components/core/paragraph/paragraph-component";
import FactCardComponent from "/components/core/fact-card/fact-card-component";
import { StyledFactCardsComponent } from "./fact-cards-component.scss";
class FactCardsComponent extends PureComponent {
    render() {
        const { paragraph, general, cards } = this.props;
        return /*#__PURE__*/ _jsxs(StyledFactCardsComponent, {
            className: "fact-cards-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "header",
                    children: /*#__PURE__*/ _jsx(ParagraphComponent, _object_spread({}, paragraph))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "cards",
                    children: cards.map((card, index)=>/*#__PURE__*/ _jsx(FactCardComponent, _object_spread({}, card, general), index))
                })
            ]
        });
    }
    constructor(props){
        super(props);
    }
}
export { FactCardsComponent as default };
FactCardsComponent.defaultProps = {
    cards: []
};
